const truncateString = (string: unknown, max?: number, sign = "...") => {
  if (typeof string !== "string") {
    return "";
  }

  return max && string.length > max ? `${string.slice(0, max)}${sign}` : string;
};

export default truncateString;
